import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

const base = 'cooking-v2';

@inject('ProductionStore')
@observer
class InstaServiceProductionCategory extends Component{
    state = {
        hours: '--',
        minutes: '--',
        seconds: '--',
        appearTimestamp: null,
    };

    componentDidMount = () => {
        const { category, ProductionStore } = this.props;
        const then = moment();

        if (ProductionStore.lastOrderTimeStamp == null || category.created_date > ProductionStore.lastOrderTimeStamp) {
            ProductionStore.lastOrderTimeStamp = category.created_date;
        }

        if (!this.state.appearTimestamp) {
            this.setState({ appearTimeStamp: then });
        }
        this.setCountdown();
    };

    componentDidUpdate = (prevProps) => {
        const { category } = this.props;
        if (category.created_date !== prevProps.category.created_date) {
            this.resetCountdown();
            this.setCountdown();
        }
    };

    componentWillUnmount() {
        this.resetCountdown();
    }

    resetCountdown = () => {
        if (this.interval) clearInterval(this.interval);
        this.setState({
            hours: '--',
            minutes: '--',
            seconds: '--',
        });
    };

    setCountdown = () => {
        this.interval = setInterval(this.countdown, 1000);
    };

    countdown = () => {
        const { category, ProductionStore } = this.props;
        const now = moment(category.created_date, 'x');
        const then = moment();

        const duration = moment.duration(then.diff(now)).asMilliseconds();

        const hours = moment.utc(duration).format('H');
        const minutes = moment.utc(duration).format('mm');
        const seconds = moment.utc(duration).format('ss');

        if (duration < 0) {
            // future order.
            this.setState({
                hours,
                minutes,
                seconds,
            });
        } else {
            if (this.state.appearTimestamp == null) {
                this.setState({ hours, minutes, seconds, isNewOrder: true, appearTimestamp: then });
            } else {
                this.setState({
                    hours,
                    minutes,
                    seconds
                });
            }
        }
    };

    chunkArray = (array, chunkSize) => {
        let results = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            results.push(array.slice(i, i + chunkSize));
        }
        return results;
    }

    render() {
        const { category } = this.props;
        const {
            hours,
            minutes,
            seconds,
        } = this.state;

        const maxColumns = 2;
        const totalItems = category.items || [];
        const columnCount = Math.min(maxColumns, Math.max(totalItems.length, 1));
        const rowsPerColumn = Math.ceil(totalItems.length / columnCount);
        const chunkedItems = this.chunkArray(totalItems, rowsPerColumn);

        return (
        <div className={`${base}__warmer_sku_category`}>
            {category.items != null &&
            category.items.length > 0 && (
                <table className={`${base}__warmer_sku_items_table`}>
                    <thead>
                        <th colSpan={chunkedItems.length}>
                            {/* Create header columns based on the number of chunks */}
                            <div className={`${base}__warmer_category_name ${base}__insta_service_category_header`}>
                                <div className={`${base}__insta_service_category_name`}>{category.category}</div>
                                <div className={`${base}__insta_service_category_actions`}>
                                    <p className={`${base}__insta_service_category_timer`}>
                                        {`${
                                            parseInt(hours) > 0 ? `${hours}:` : ``
                                        }${minutes}:${seconds}`}
                                    </p>
                                </div>
                            </div>
                        </th>
                    </thead>
                    <tbody className={`${base}__insta_service_category_body`}>
                        {/* Loop through the chunked array and create rows */}
                        {Array.from({ length: rowsPerColumn }).map((_, rowIndex) => (
                            <tr key={`row-${rowIndex}`} style={{ borderSpacing: 0}}>
                                {chunkedItems.map((col, colIndex) => (
                                    <td key={`cell-${rowIndex}-${colIndex}`} style={{ width: `${100 / columnCount}%` }}>
                                        {/* Ensure item exists in the column */}
                                        {chunkedItems[colIndex][rowIndex] && (
                                            <div className={`${base}__warmer_sku_items`}>
                                                <div className={`${base}__warmer_item_container`}>
                                                    <span className={`${base}__warmer_item_name`}>
                                                        {chunkedItems[colIndex][rowIndex].quantity} x {chunkedItems[colIndex][rowIndex].name || ''}
                                                    </span>
                                                    {chunkedItems[colIndex][rowIndex].oos && (
                                                            <p className={`${base}__oos-tag`}>OOS</p>
                                                        )}
                                                </div>
                                            </div>
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
        )
    };
}
export default InstaServiceProductionCategory;
